import { render, staticRenderFns } from "./asset_detail.vue?vue&type=template&id=2323199e&scoped=true"
import script from "./asset_detail.vue?vue&type=script&lang=js"
export * from "./asset_detail.vue?vue&type=script&lang=js"
import style0 from "./asset_detail.vue?vue&type=style&index=0&id=2323199e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2323199e",
  null
  
)

export default component.exports